import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import { MagnifyGlass } from '../../../../../static/icons/iconMagnifyingglass';
import colors from '../../../../../tailwind.colors';

const CategorySearch = ({ handleInputChange, setOpenSearch, t }) => {
  const handleInputBlur = () => {
    setTimeout(() => {
      setOpenSearch(false);
    }, 200);
  };

  return (
    <Stack className="w-full mt-10">
      <Typography
        textAlign="left"
        fontVariant="md"
        as="label"
        className="font-normal"
        htmlFor="search_systems"
      >
        {t('guide.searchAmongCategories')}
      </Typography>
      <div className="relative" onBlur={handleInputBlur}>
        <input
          id="search_systems"
          type="text"
          className="w-full font-ubuntu text-clamp-md h-16 bg-white border border-customGray-300 rounded-lg pl-6 pr-16 placeholder:text-customGray-500 placeholder:text-clamp-md placeholder:font-light focus:outline-none"
          placeholder={t('guide.searchForCategoryPlaceholder')}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
        />
        <div className="absolute flex items-center right-6 top-0 h-full">
          <MagnifyGlass color={colors.primary[500]} />
        </div>

        {/* openSearch && (
          <div className="absolute top-14 border-x border-b h-auto max-h-64 overflow-x-auto border-customGray-300 w-full bg-white rounded-b-lg shadow-md z-10">
            <Stack>
              {results.length > 0 ? (
                results.map((category) => (
                  <button
                    type="button"
                    key={category.dbName}
                    onClick={() => onSelectCategory(category.name)}
                    className="h-10 flex items-center global-hover pl-6"
                  >
                    <Typography fontVariant="sm">{category.name}</Typography>
                  </button>
                ))
              ) : (
                <Typography
                  textTransform="uppercase"
                  fontVariant="sm"
                  className="py-4"
                >
                  {t('common.noResults')}
                </Typography>
              )}
            </Stack>
          </div>
        ) */}
      </div>
    </Stack>
  );
};

export default CategorySearch;
